import styled from "styled-components";

export const Container = styled.div`
  width: 24.375rem;
  height: 52.75rem;
  display: block;
  justify-content: center;
  margin: 0 auto;
`;
export const Button = styled.div`
  margin: 0 auto;
  width: 18rem;
  height: 2.25rem;
  flex-shrink: 0;
  border-radius: 0.25rem;
  background: #351182;
  color: #fff;
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
export const P = styled.p`
  width: 14.93756rem;
  color: #474747;
  text-align: center;
  font-family: Inter;
  font-size: 1.3125rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 2.69em auto;
`;
export const ImageContainer = styled.div`
  width: 15.5rem;
  height: 15.5rem;
  flex-shrink: 0;
  margin: 0 auto;
  margin-top: 10em;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
